import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import type { IButtonProps } from '@fluentui/react/lib/Button';
import type { CharmControlProps } from 'owa-charmcontrol';

export type Detail = TextDetailPart | CustomDetailPart | ButtonDetailPart;

export interface TextDetailPart {
    getTextProps: () => { text: string; className?: string };
    getCharmControllProps?: () => CharmControlProps;
    colorScheme?: ColorScheme;
    className?: string;
}

export interface ButtonDetailPart {
    buttonProps: IButtonProps;
    colorScheme?: ColorScheme;
}

export interface CustomDetailPart {
    renderCustomDetailPart: () => JSX.Element;
}

export const isCustomDetailPart = (detailPart: Detail): detailPart is CustomDetailPart => {
    return !!(<CustomDetailPart>detailPart).renderCustomDetailPart;
};

export const isTextDetailPart = (detailPart: Detail): detailPart is TextDetailPart => {
    return !!(<TextDetailPart>detailPart).getTextProps;
};

export const isButtonDetailPart = (detailPart: Detail): detailPart is ButtonDetailPart => {
    return !!(<ButtonDetailPart>detailPart).buttonProps;
};
